import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import type { IActions } from '../interface/IAction';
import type { IStates } from '../interface/IReducer';
import { actions as actionCreators } from '../store/actions';
import type { RootState } from '../store/configureStore';

export const useStoreState = (): IStates =>
	useSelector((state: RootState) => state, { devModeChecks: { identityFunctionCheck: 'never' } }) as IStates;

export const useActions = (): IActions => {
	const dispatch = useDispatch();
	return useMemo(() => bindActionCreators(actionCreators, dispatch) as unknown as IActions, [dispatch]);
};
